<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row>
        <b-col xl="3" md="6">
          <stats-card
            type="gradient-info"
            icon="ni ni-chart-bar-32"
            class="mb-4"
          >
            <h5 class="card-title text-uppercase text-muted mb-0">
              JUMLAH KUESIONER
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ tableData.length }}</span>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <!--Tables-->
            <b-row class="mt-2">
              <b-col xl="12" class="mb-5 mb-xl-0">
                <b-card body-class="p-0" header-class="border-0">
                  <template v-slot:header>
                    <b-row align-v="center">
                      <b-col>
                        <h3 class="mb-0">Data Kuesioner</h3>
                      </b-col>
                      <b-col class="text-right">
                        <b-button
                          class="btn btn-sm btn-info"
                          v-b-modal.modal-prevent-closing
                          ><i class="ni ni-fat-add"></i>Tambah
                          Kuesioner</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>

                  <div class="padding">
                    <v-client-table
                      :data="tableData"
                      :columns="columns"
                      :options="options"
                    >
                      <template slot="actions" slot-scope="{ row }">
                        <button
                          v-if="row.status == 1"
                          @click="updateItem(row)"
                          class="btn btn-sm btn-warning"
                        >
                          dinonaktifkan
                        </button>
                        <button
                          v-if="row.status == 0"
                          @click="updateItem(row)"
                          class="btn btn-sm btn-success"
                        >
                          aktifkan
                        </button>
                        <button
                          @click="editItem(row.id)"
                          class="btn btn-sm btn-info"
                        >
                          <i class="ni ni-curved-next"></i>
                        </button>
                        <button
                          @click="deleteItem(row)"
                          class="btn btn-sm btn-danger"
                        >
                          <i class="ni ni-fat-remove"></i>
                        </button>
                      </template>
                    </v-client-table>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <!--End tables-->

            <!-- modal -->
            <b-modal
              id="modal-prevent-closing"
              ref="modal"
              title="Tambah Kuesioner"
              @show="resetModal"
              @hidden="resetModal"
              @ok="handleOk"
            >
              <form ref="form" @submit.stop.prevent="handleSubmit">
                <div
                  v-if="message"
                  class="alert alert-danger rounded mb-3"
                  role="alert"
                >
                  {{ message }}
                </div>

                <div class="row">
                  <div class="col-sm-12 mb-4">
                    <select
                      name="category"
                      class="form-select form-control"
                      v-model="survey.category"
                      v-validate="'required'"
                    >
                      <option value="">---- Pilih Kategori ----</option>
                      <option
                        v-for="category in data.categories"
                        :key="category.id"
                        :value="category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  v-if="errors.has('category')"
                  class="alert alert-danger rounded mb-3"
                  role="alert"
                >
                  Kategory wajib diisi!
                </div>

                <div class="row">
                  <div class="col-12 mb-4">
                    <input
                      v-validate="'required'"
                      v-model="survey.name"
                      type="text"
                      class="form-control"
                      name="name"
                      placeholder="Nama Kuesioner"
                    />
                  </div>
                </div>
                <div
                  v-if="errors.has('name')"
                  class="alert alert-danger rounded mb-3"
                  role="alert"
                >
                  Nama Kuesioner Wajib diisi!
                </div>
              </form>
            </b-modal>
            <!-- end-modal -->
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseHeader from "@/components/admin/BaseHeader";
import SurveyService from "@/services/survey.service";
import Loading from "@/components/Loading.vue";

export default {
  name: "List",
  components: {
    BaseHeader,
    Loading
  },
  data() {
    return {
      loading: false,
      message: "",
      survey: {
        name: "",
        category: ""
      },
      data: {
        categories: [
          {
            id: 1,
            name: "Kuesioner D3 dan S1"
          },
          {
            id: 2,
            name: "Kuesioner Pascasarjana dan Profesi"
          },
          {
            id: 3,
            name: "Kuesioner Profesi Keinsinyuran"
          },
          {
            id: 4,
            name: "User Survey (Atasan)"
          }
        ]
      },
      columns: [
        "id",
        "survey_category",
        "name",
        "updated_at",
        "actions",
        "status",
        "survey_category_id"
      ],
      tableData: [],
      options: {
        headings: {
          survey_category: "Kategori Kuesioner  ",
          name: "Nama Kuesioner  ",
          updated_at: "Update  ",
          actions: "Aksi"
        },
        sortable: true,
        filterable: true,
        hiddenColumns: ["id", "status", "survey_category_id"],
        texts: {
          count:
            "Menampilkan {from} sampai {to} dari {count} data|{count} data|Satu data",
          first: "Pertama",
          last: "Terahkir",
          filter: false,
          filterPlaceholder: "Pencarian",
          limit: false,
          page: "Page:",
          noResults: "Data tidak ada",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns"
        },
        sortIcon: {
          is: "fa fa-sort",
          base: "font-awesome",
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          align: "center"
        },
        pagination: {
          show: true,
          dropdown: false,
          chunk: 5,
          edge: false,
          align: "center",
          nav: "fixed"
        }
      }
    };
  },
  mounted() {
    this.getSurveys();
  },
  watch: {
    page() {
      this.getSurveys();
    }
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.survey.name = "";
      this.survey.category = "";
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },

    handleSubmit() {
      let data = {
        name: this.survey.name,
        category: this.survey.category,
        json: {
          pages: []
        }
      };
      SurveyService.createListSurveys(data)
        .then(res => {
          console.log(res.data.message);
          this.getSurveys();
          this.$nextTick(() => {
            this.$bvModal.hide("modal-prevent-closing");
          });
        })
        .catch(error => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        });
    },
    getSurveys() {
      this.loading = true;
      this.$store.commit("SHOW_LOADING", "Memuat data kuesioner...");
      SurveyService.getListSurveys()
        .then(res => {
          this.tableData = res.data.surveys;
          this.loading = false;
          this.$store.commit("HIDE_LOADING");
        })
        .catch(error => {
          this.loading = false;
          this.$store.commit("HIDE_LOADING");
          console.error(error);
        });
    },
    editItem(id) {
      this.$router.push({ name: "edit-kuesioner", params: { id: id } });
    },
    deleteItem(row) {
      this.$swal({
        title: "Yakin ingin menghapus?",
        text: "Anda tidak akan dapat mengembalikan ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus!",
        cancelButtonText: "Batal"
      }).then(result => {
        if (result.value) {
          SurveyService.deleteListSurvey(row.id)
            .then(response => {
              this.$swal("Data berhasil dihapus");
              this.getSurveys();
            })
            .catch(error => {
              this.$swal({ icon: "error", title: "Terjadi kesalahan" });
            });
        }
      });
    },
    updateItem(row) {
      let data = {
        id: row.id,
        status: row.status,
        category_id: row.survey_category_id
      };
      SurveyService.updateStatusSurvey(data)
        .then(res => {
          this.getSurveys();
        })
        .catch(error => console.error(error));
    }
  }
};
</script>

<style scoped>
.padding {
  padding: 20px !important;
}
</style>
